<div class="content__container pacchetto">
  <div class="left__side__content" *ngIf="(fromBase && !isMobile) || !fromBase">
    <div class="image__container">
      <img
        src="{{ pacchetto.imgsrc }}"
        alt="Immagine Wine Box {{ pacchetto.nome }}"
        title="Immagine Wine Box {{ pacchetto.nome }}"
        class="image__img"
      />
    </div>
  </div>
  <div class="right__side__content">
    <div class="goback__wrapper" *ngIf="pacchettoSelezionato">
      <div class="goback__item" (click)="tornaIndietro()">
        <span class="material-symbols-outlined"> chevron_left </span>
        {{ "base.altri_pacchetti" | translate }}
      </div>
    </div>
    <h2 class="d-flex align-items-baseline flex-header">
      <b>
        {{ pacchetto.nome }}
      </b>
    </h2>
    <div class="tags" *ngIf="pacchetto.tags && pacchetto.tags.length > 0">
      <app-tags-vino [tags]="pacchetto.tags"></app-tags-vino>
    </div>
    <div class="price__container">
      <div class="prezzo-box">
        <div class="prezzo scontato" *ngIf="pacchetto.hasSconto()">
          € {{ pacchetto.choosePrezzoScontato() | number : "1.2-2" }}
        </div>
        <div
          class="prezzo"
          [ngClass]="pacchetto.hasSconto() ? 'inSconto' : 'not-inSconto'"
        >
          € {{ pacchetto.costo | number : "1.2-2" }}
        </div>
      </div>
    </div>
    <div
      class="associata"
      *ngIf="pacchetto.associate && pacchetto.associate_sconto != 0"
    >
      <span *ngIf="pacchetto.associate_sconto == 100">
        {{ "base.visita_inclusa_tot" | translate }}
      </span>
      <span
        *ngIf="
          pacchetto.associate_sconto != 100 && pacchetto.associate_sconto != 0
        "
      >
        {{
          "base.visita_inclusa_parziale"
            | translate : { value: pacchetto.associate_sconto }
        }}
      </span>
      <span *ngIf="!pacchetto.associate"> &nbsp; </span>
    </div>
    <hr class="divisore" />

    <div class="mb-descrizione">
      <app-testo-espandibile [text]="pacchetto.descrizione">
      </app-testo-espandibile>
    </div>

    <div *ngIf="pacchetto.vini && pacchetto.vini.length > 0" class="mb-2 mt-2">
      <h2 class="head">
        {{ "base.vini_inclusi_winebox" | translate }}
      </h2>
      <div class="mt-05">
        <app-vini-inclusi [vini]="pacchetto.vini"></app-vini-inclusi>
      </div>
    </div>

    <div id="midbase">
      <div *ngIf="pacchettoSelezionato" id="last_step">
        <app-acquisto-pacchetto
          [pacchetto]="pacchettoSelezionato"
          (refreshCart)="refreshCart()"
        ></app-acquisto-pacchetto>
      </div>
    </div>
  </div>
</div>
